import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import BgImg from "../../../images/case-studies/rev-coin/green_bg.png";

function Incorporatepoint() {
  return (
    <section
      className="incorporate_point p-100"
      style={{ backgroundImage: `url(${BgImg})`, backgroundColor: "#000" }}
    >
      <Container fluid>
        <Row>
          <Col
            xs={12}
            md={12}
            lg={12}
            xl={12}
            xxl={12}
            className="m-auto text-center"
          >
            <div className="green-content">
              <h2 style={{ color: "#000" }}>
                Trade with a new way in a new world - Trade with a new way in a
                new world - Trade with a new way in a new world - Trade with a
                new way in a new world Trade with a new way in a new world -
                Trade with a new way in a new world - Trade with a new way in a
                new world - Trade with a new way in a new world Trade with a new
                way in a new world - Trade with a new way in a new world - Trade
                with a new way in a new world - Trade with a new way in a new
                world Trade with a new way in a new world - Trade with a new way
                in a new world - Trade with a new way in a new world - Trade
                with a new way in a new world Trade with a new way in a new
                world - Trade with a new way in a new world - Trade with a new
                way in a new world - Trade with a new way in a new world Trade
                with a new way in a new world - Trade with a new way in a new
                world - Trade with a new way in a new world - Trade with a new
                way in a new world Trade with a new way in a new world - Trade
                with a new way in a new world - Trade with a new way in a new
                world - Trade with a new way in a new world Trade with a new way
                in a new world - Trade with a new way in a new world - Trade
                with a new way in a new world - Trade with a new way in a new
                world Trade with a new way in a new world - Trade with a new way
                in a new world - Trade with a new way in a new world - Trade
                with a new way in a new world Trade with a new way in a new
                world - Trade with a new way in a new world - Trade with a new
                way in a new world - Trade with a new way in a new world Trade
                with a new way in a new world - Trade with a new way in a new
                world - Trade with a new way in a new world - Trade with a new
                way in a new world Trade with a new way in a new world - Trade
                with a new way in a new world - Trade with a new way in a new
                world - Trade with a new way in a new world Trade with a new way
                in a new world - Trade with a new way in a new world - Trade
                with a new way in a new world - Trade with a new way in a new
                world Trade with a new way in a new world - Trade with a new way
                in a new world - Trade with a new way in a new world - Trade
                with a new way in a new world
              </h2>
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Incorporatepoint;
